module.exports = __webpack_public_path__ + "img/item8.bf20ad56.png";